import $ from "jquery";
import HelpShiftContentRequester from './HelpShiftRequester';

$(document).ready(function () {
    const body = $('body');
    const helpShift = $('.help-shift-categories');

    const contentRequester = new HelpShiftContentRequester(
        $(".help-system__content-inner"),
        $('.help-shift-nav')
    );

    if (typeof helpShift === 'undefined')
        return;

    body.on('click', '.category-row .tree-btn', function () {
        const target = $(this).closest('.category-row');
        const categoryId = target.data('id');

        toggleSubCategories(categoryId);
        toggleCategorySign(target);

        return false;
    });

    body.on('click', '.category-row a', function (event) {
        event.preventDefault();
        const target = $(this).closest('.category-row');
        const categoryId = target.data('id');

        slideDownSubCategories(categoryId);
        makeCategoryActive(target);
        changeCategorySignToMinus(target);

        contentRequester.requestCategory(categoryId, $(this).attr('href'), 50);

        return false;
    });

    body.on('click', '.article-row', function () {
        makeArticleActive($(this));

        contentRequester.requestArticle($(this).data('id'), $(this).attr('href'));

        return false;
    });

    window.onpopstate = function () {
        /**
         * Expected urls are:
         *      /help/article/5 => ['', 'help', 'article', '5']
         *      /help/category/8 => ['', 'help', 'category', '8']
         */
        const backRequestArgs = (document.location.pathname + "").split('/').slice(2);
        const type = backRequestArgs[0];
        const id = backRequestArgs[1];
        switch (type) {
            case 'category':
                const categoryRow = $(`.category-row[data-id="${id}"]`);

                makeCategoryActive(categoryRow);
                changeCategorySignToMinus(categoryRow);
                slideDownSubCategories(id);
                slideDownParentCategory(categoryRow.data('parent-id'));

                contentRequester.requestCategory(id);
                return;

            case 'article':
                const articleRow = $(`.article-row[data-id="${id}"]`);
                makeArticleActive(articleRow);
                slideDownParentCategory(articleRow.data('parent-id'));

                contentRequester.requestArticle(id);
                return;

        }
    };

    function toggleSubCategories(categoryId) {
        const $elem = $('#childrenOf' + categoryId);
        prepareSubCategoriesToSlides($elem);
        $elem.slideToggle(200);
    }

    function slideDownSubCategories(categoryId) {
        const $elem = $('#childrenOf' + categoryId);
        prepareSubCategoriesToSlides($elem);
        $elem.slideDown(200);
    }

    function prepareSubCategoriesToSlides($elem) {
        if ($elem.hasClass('hidden')) {
            $elem.removeClass('hidden');
            $elem.hide();
        }
    }

    function makeCategoryActive($categoryRow) {
        helpShift.find('.category-row').removeClass('active-category');
        helpShift.find('.article-row').removeClass('active-article');
        $categoryRow.addClass('active-category');
    }

    function makeArticleActive($articleRow) {
        helpShift.find('.category-row').removeClass('active-category');
        helpShift.find('.article-row').removeClass('active-article');
        $articleRow.addClass('active-article');
    }

    function toggleCategorySign($categoryRow) {
        const sign = $categoryRow.find('.category-sign');
        if (sign.length === 1) {
            if (sign.hasClass('tree-btn__plus')) {
                sign.removeClass('tree-btn__plus');
                sign.addClass('tree-btn__minus');
            } else {
                sign.removeClass('tree-btn__minus');
                sign.addClass('tree-btn__plus');
            }
        }
    }

    function changeCategorySignToMinus($categoryRow) {
        const sign = $categoryRow.find('.category-sign');
        if (sign.length === 1) {
            if (sign.hasClass('tree-btn__plus')) {
                sign.removeClass('tree-btn__plus');
                sign.addClass('tree-btn__minus');
            }
        }
    }

    function slideDownParentCategory(categoryId) {
        console.log(categoryId);
        if (categoryId === 1)
            return;
        slideDownSubCategories(categoryId);
        const parentId = $(`.category-row[data-id=${categoryId}]`).data('parent-id');
        slideDownParentCategory(parentId);
    }
});
